import React from 'react';


const CheckBox = ({width}) => (
  <svg width={width || "25px"} viewBox="0 0 300 300" >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Desktop-HD-Copy" transform="translate(-519.000000, -285.000000)">
              <g id="Group-2" transform="translate(519.000000, 285.000000)">
                  <rect id="Rectangle" fill="#2B68B2" x="0" y="0" width="300" height="300" rx="20"></rect>
                  <g id="Group" transform="translate(149.944697, 122.944697) rotate(-45.000000) translate(-149.944697, -122.944697) translate(51.944697, 73.944697)" fill="#FFFFFF">
                      <rect id="Rectangle" x="1" y="83" width="194" height="15" rx="7.5"></rect>
                      <path d="M-32.9802307,41.226876 L49.0197693,41.226876 C53.1619049,41.226876 56.5197693,44.5847404 56.5197693,48.726876 L56.5197693,48.726876 C56.5197693,52.8690117 53.1619049,56.226876 49.0197693,56.226876 L-32.9802307,56.226876 C-37.1223664,56.226876 -40.4802307,52.8690117 -40.4802307,48.726876 L-40.4802307,48.726876 C-40.4802307,44.5847404 -37.1223664,41.226876 -32.9802307,41.226876 Z" id="Rectangle-Copy" transform="translate(8.019769, 48.726876) rotate(-90.000000) translate(-8.019769, -48.726876) "></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
);

export default CheckBox;
